import { Box, Grid, Heading, Text } from "@chakra-ui/react";
import { CtaButton, Reveal } from "@/components";
import { PRICING_CTA } from "@/content";

export const PricingCta = () => (
  <Box as="section" id="pricing" maxW="maxw" mx="auto" px="pad" py="sec">
    <Reveal>
      <Grid
        maxW="1000px"
        mx="auto"
        px="clamp(24px, 4vw, 64px)"
        py="clamp(40px, 5vw, 80px)"
        borderRadius="lg"
        bg="surface.white"
        border="1px solid"
        borderColor="line.hairline"
        gap="18px"
        justifyItems="center"
        textAlign="center"
      >
        <Text variant="eyebrowBrand">{PRICING_CTA.eyebrow}</Text>
        <Heading as="h2" variant="section" lineHeight={0.85} maxW="16ch">
          {PRICING_CTA.title}
        </Heading>
        <Text variant="lede" maxW="44ch">
          {PRICING_CTA.lede}
        </Text>
        <Box mt="10px" display="flex" flexWrap="wrap" justifyContent="center" gap="14px">
          <CtaButton href={PRICING_CTA.primary.href} variant="brand" px="44px" data-group>
            {PRICING_CTA.primary.label}
            <Box
              as="span"
              aria-hidden="true"
              transitionProperty="transform"
              transitionDuration="0.25s"
              transitionTimingFunction="brand"
              _groupHover={{ transform: "translateX(4px)" }}
            >
              →
            </Box>
          </CtaButton>
          <CtaButton href={PRICING_CTA.secondary.href} external={PRICING_CTA.secondary.external} variant="ghost">
            {PRICING_CTA.secondary.label}
          </CtaButton>
        </Box>
      </Grid>
    </Reveal>
  </Box>
);
